// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TGzF","icon":"styles_icon__tBo2v"};